module.exports = __webpack_public_path__ + "img/8.892644f7.png";